/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ModalPaymentIframeAliases {
  I_FRAME_PAYMENT = 'i-frame-payment',
}
export { ModalPaymentIframeAliases };
